module.exports = __webpack_public_path__ + "static/media/Hours of Wealth.e079203e.jpg";